import { withTranslation } from "react-i18next";
import { enUS, de, ar } from "date-fns/locale"; // Import locales
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const ITEMS_COUNT_PAGINATION_OPTION = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  // { value: 50, label: "50" },
];
export const SCORINGOPTIONS = [
  { value: "SUM", label: "Sum" },
  { value: "AVERAGE", label: "Average" },
  { value: "PERCENTAGE", label: "Percentage" },
  { value: "MULTIPLY", label: "Multiply" },
];
export const RISKPARAMCOLORS = [
  { value: "#DB0001", label: "Red" },
  { value: "#FF681C", label: "Orange" },
  { value: "#DABE25", label: "Yellow" },
  { value: "#2AA815", label: "Green" },
  { value: "#007BFF", label: "Blue" },
];
export const SCORINGOPERATOR = [
  { value: "NONE", label: "None" },
  { value: "ADD", label: "Add" },
  // { value: "SUBTRACT", label: "Subtract" },
  { value: "MULTIPLY", label: "Multiply" },
];
export const SORT_ORDER_DESC = "desc";
export const SORT_ORDER_ASC = "asc";
export const LIST_DEF_SORT = "createdDate";
export function RiskReportFrequency({ t }) {
  const options = [
    { value: "ANNUAL", label: t("ANNUAL.label") },
    { value: "QUARTERLY", label: t("QUARTERLY.label") },
    { value: "HALF_YEARLY", label: t("HALF_YEARLY.label") },
    { value: "FINANCIAL_YEAR", label: t("FINANCIAL_YEAR.label") },
  ];
  return options;
} withTranslation()(RiskReportFrequency);
export const STATUS =
{
  DRAFT: "Draft",
  PUBLISHED: "Published",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  ONBOARDED: "Onboarded",
  INVITED: "Invited",
  ACCEPTED: "Accepted",
  NEW: "New",
  PENDING: "Pending",
  CLOSED: "Closed",
  UNDER_INVESTIGATION: "Under Investigation",
  REJECTED: "Rejected",
  FINALIZED: "Finalized",
  SUBMITTED: "Submitted",
  NOT_STARTED: "Not Started",
  NOT_SUBMITTED: 'Not Submitted',
  NOT_SHARED: 'Not Shared',
  GENERATING_REPORT: 'Generating Report',
  PENDING_APPROVAL: 'Pending Approval',
  REVIEW_IN_PROGRESS: 'Review In Progress',
  APPROVED: 'Approved',
  EXPIRED: 'Expired',
  CORRECTION_PENDING: 'Correction Pending',
  NO_PERMISSION: 'No Permission',
  FAILED: 'Failed'
}
  ;
export const RISKSTATUS =
{
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
  CRITICAL: "Critical"
}
  ;

export const FORM_BUILDER_LISTING_URL = process.env.REACT_APP_FORM_BUILDER_URL + '/form_list';
export const FORM_BUILDER_REVIEW_URL = process.env.REACT_APP_FORM_BUILDER_URL + '/form_list';
export const FORM_BUILDER_EDIT_URL = process.env.REACT_APP_FORM_BUILDER_URL + "/form_edit";
export const FORM_BUILDER_OPEN_SUBMIT_URL = process.env.REACT_APP_FORM_BUILDER_URL + "/open-form/submit";

export const Regulations = [
  { regulation: "LKSG", code: "LKSG" },
  { regulation: "VSOTR", code: "VSOTR" },
  { regulation: "FINANCIAL_RISK", code: "FINANCIAL_RISK" },
];
export const LOADER_COLOR = "#383cc1";


export const TEXT_TRUNCATION_MAX_LENGTH = 150;

export const TaskStatus = {
  NEW: 0,
  IN_PROGRESS: 1,
  CLOSED: 2
};

export const INCIDENTSTATUS = [
  { key: "ACCEPTED", value: "Accepted" },
  { key: "CLOSED", value: "Closed" },
  { key: "NEW", value: "New" },
  { key: "REJECTED", value: "Rejected" },
  { key: "UNDER_INVESTIGATION", value: "Under Investigation" },
];

export const USER_ROLE = {
  SUPER_ADMIN: "SUPER_ADMIN",
   SUPPORT_USER: "SUPPORT_USER",
  SUPPLIER_ADMIN: "SUPPLIER_ADMIN",
   SUPPLIER_RISK_ASSESSOR: "SUPPLIER_RISK_ASSESSOR",
   SUPPLIER_TEAM_MEMBER: "SUPPLIER_TEAM_MEMBER",
   CONSULTANT: "CONSULTANT",

  //*************User Roles after introducing keycloak**********
  
  //for data management
  DM_VIEW_PERIODIC: "VIEW_QUANT_DATA",
  DM_UPDATE_PERIODIC: "UPDATE_QUANT_DATA",
  DM_VIEW_ONETIME: "VIEW_QUAL_DATA",
  DM_UPDATE_ONETIME: "UPDATE_QUAL_DATA",
  DM_DELETE_ONETIME: "DELETE_QUAL_DATA",


  //for reporting studio
  REPORTING_STUDIO_VIEW:"VIEW_RS",
  REPORTING_STUDIO_UPDATE:"UPDATE_RS",
  REPORTING_STUDIO_DELETE:"DELETE_RS",

  VIEW_GRI:"VIEW_GRI_REPORT",
  UPDATE_GRI:"UPDATE_GRI_REPORT",

  VIEW_BRSR:"VIEW_BRSR_REPORT",
  UPDATE_BRSR:"UPDATE_BRSR_REPORT",

  VIEW_GHG:"VIEW_GHG_REPORT",
  UPDATE_GHG:"UPDATE_GHG_REPORT",

  VIEW_CSRD:"VIEW_CSRD_REPORT",
  UPDATE_CSRD:"UPDATE_CSRD_REPORT",

  VIEW_VSME:"VIEW_VSME_REPORT",
  UPDATE_VSME:"UPDATE_VSME_REPORT",

  VIEW_UAE_FDL:"VIEW_UAE_FDL_REPORT",
  UPDATE_UAE_FDL:"UPDATE_UAE_FDL_REPORT",

  //for Goals and KPIs
  GOALS_AND_KPIS_VIEW:"VIEW_GOALS_KPI",
  GOALS_AND_KPIS_UPDATE:"UPDATE_GOALS_KPI",

  //for Double materiality
  DOUBLE_MATERIALITY_VIEW:"VIEW_DMAT",
  DOUBLE_MATERIALITY_UPDATE:"UPDATE_DMAT",

  //for GHG emissions
  GHG_EMISSIONS_VIEW:"VIEW_GHG",
  GHG_EMISSIONS_UPDATE:"UPDATE_GHG",

  //for Consultant


  //for Home 
  HOME_VIEW:"VIEW_HOME",

  //for Dashboard
  DASHBOARD_VIEW:"VIEW_DASHBOARD",
  DASHBOARD_UPDATE:"UPDATE_DASHBOARD",

  //for Data Collection
  DATA_COLLECTION_VIEW:"VIEW_DCE",
  DATA_COLLECTION_UPDATE:"UPDATE_DCE",
  
  //for Configuration

  CONFIGURATIONS_VIEW:"VIEW_CONFIG",
  CONFIGURATIONS_UPDATE:"UPDATE_CONFIG",

  //for Settings

  SETTINGS_VIEW:"VIEW_SETTINGS",
  SETTINGS_UPDATE:"UPDATE_SETTINGS",

  //for User inside Settings

  USER_VIEW:"VIEW_USER",
  USER_UPDATE:"UPDATE_USER",


  //for Chat with Data
  CHAT_WITH_DATA:"VIEW_CWD",
  
  // Previleged permissions
  REVOKE_DCE_SUBMISSION: "REVOKE_DCE_SUBMISSION"



};

export const TaskPriority = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
  CRITICAL: 3
};
export const ASSESSMENTSCORINGMETHODS = [
  {
    name: "None",
    key: "NONE",
  },
  {
    name: "Average",
    key: "AVERAGE",
  },
  {
    name: "Sum",
    key: "SUM",
  },
];
export const FORMTYPES = [
  { value: "SUPPLIERASSESSMENT", label: "Supplier Assessment" },
  { value: "SELFASSESSMENT", label: "Self Assessment" },
  { value: "MATERIALITY", label: "Materiality" }
];
export const ASSESSMENTFORMTXT = 'SUPPLIERASSESSMENT';


export const IncidentPriority = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2
};
export const startYear = 2021;
export const currentYear = new Date().getFullYear();
export function MetricCategory({ t }) {
  const options = [
    { value: "QUANTITATIVE", label: t("QUANTITATIVE.label") },
    { value: "QUALITATIVE", label: t("QUALITATIVE.label") },
  ];
  return options;
} withTranslation()(MetricCategory);
export function StadardReportFrequency({ t }) {
  const options = [
    { value: "ANNUAL", label: t("ANNUAL.label") },
    { value: "MONTHLY", label: t("MONTHLY.label") },
    { value: "QUARTERLY", label: t("QUARTERLY.label") },
    { value: "HALF_YEARLY", label: t("HALF_YEARLY.label") },
    { value: "FINANCIAL_YEAR", label: t("FINANCIAL_YEAR.label") },
  ];
  return options;
} withTranslation()(StadardReportFrequency);
export function Months({ t }) {
  const options = [
    { value: "01", label: t("January.label") },
    { value: "02", label: t("February.label") },
    { value: "03", label: t("March.label") },
    { value: "04", label: t("April.label") },
    { value: "05", label: t("May.label") },
    { value: "06", label: t("June.label") },
    { value: "07", label: t("July.label") },
    { value: "08", label: t("August.label") },
    { value: "09", label: t("September.label") },
    { value: "10", label: t("October.label") },
    { value: "11", label: t("November.label") },
    { value: "12", label: t("December.label") },
  ];
  return options;
} withTranslation()(Months);

export function MonthsExt({ t }) {
  const options = [
    { value: "JAN", label: t("January.label") },
    { value: "FEB", label: t("February.label") },
    { value: "MAR", label: t("March.label") },
    { value: "APR", label: t("April.label") },
    { value: "MAY", label: t("May.label") },
    { value: "JUN", label: t("June.label") },
    { value: "JUL", label: t("July.label") },
    { value: "AUG", label: t("August.label") },
    { value: "SEP", label: t("September.label") },
    { value: "OCT", label: t("October.label") },
    { value: "NOV", label: t("November.label") },
    { value: "DEC", label: t("December.label") },
  ];
  return options;
} withTranslation()(MonthsExt);

export function MonthsFull({ t }) {
  const options = [
    { value: "APRIL", label: t("April.label") },
    { value: "MAY", label: t("May.label") },
    { value: "JUNE", label: t("June.label") },
    { value: "JULY", label: t("July.label") },
    { value: "AUGUST", label: t("August.label") },
    { value: "SEPTEMBER", label: t("September.label") },
    { value: "OCTOBER", label: t("October.label") },
    { value: "NOVEMBER", label: t("November.label") },
    { value: "DECEMBER", label: t("December.label") },
    { value: "JANUARY", label: t("January.label") },
    { value: "FEBRUARY", label: t("February.label") },
    { value: "MARCH", label: t("March.label") },
  ];
  return options;
} withTranslation()(Months);

export function CategoryList({ t }) {
  return [
    { key: "ENVIRONMENTAL", value: "ENVIRONMENTAL", text: t("Environmental.label"), id: DataViewCategoryType.ENVIRONMENTAL },
    { key: "SOCIAL", value: "SOCIAL", text: t("Social.label"), id: DataViewCategoryType.SOCIAL },
    { key: "GOVERNANCE", value: "GOVERNANCE", text: t("Governance.label"), id: DataViewCategoryType.GOVERNANCE }
  ];
}

export function MaterialCategoryList({ t }) {
  return [
    { key: "ENVIRONMENTAL", value: "ENVIRONMENTAL", text: t("Environmental.label"), id: DataViewCategoryType.ENVIRONMENTAL },
    { key: "SOCIAL", value: "SOCIAL", text: t("Social.label"), id: DataViewCategoryType.SOCIAL },
    { key: "GOVERNANCE", value: "GOVERNANCE", text: t("Governance.label"), id: DataViewCategoryType.GOVERNANCE },
  ];
}


export const ReportStatus = {
  DRAFT: 0,
  FINALIZED: 1,
  NOT_STARTED: 2,
  FAILED: 3
};

export const ReportSection = {
  ROOT: 0,
  TITLE: 1,
  CONTENTS: 2,
  OTHERS: 3,
  OVERVIEW: 4,
  REPORTING: 5,
  LEADERSHIP: 6,
  ABOUT_REPORT: 7,
  ABOUT_COMPANY: 8,
  ESG_APPROACH: 9,
  ENVIRONMENT: 10,
  SOCIAL: 11,
  GOVERNANCE: 12,
  ESG_INDEX: 13,
  SCORECARD: 14,
  GENERAL_DISCLOSURE: 15,
  METHODOLOGY: 16,
  MATERIALITY_MATRIX: 17,
  GENERAL_INFO: 18,
  EXECUTIVE_SUMMARY: 100,
  ORGANIZATIONAL_PROFILE: 101,
  BASE_YEAR_METHODOLOGY: 102,
  GHG_EMISSIONS_INVENTORY: 103,
  ENERGY_USE_EMISSION_SOURCES: 104,
  GHG_REDUCTION_STRATEGY: 105,
  VERIFICATION_ASSURANCE: 106,
  ANNEXURES: 107,
  INSIGHTS: 108,
  SECTION: 200,
  PRINCIPLE: 201,
  // UAE Federal Decree-Law report sections (300+)
  UAE_FDL_ABOUT_THE_ORGANIZATION: 300,
  UAE_FDL_ABOUT_THE_REPORT: 301,
  UAE_FDL_INVENTORY_OF_GHG_EMISSIONS: 302,
  UAE_FDL_INFORMATION_ABOUT_EMISSIONS: 303,
  UAE_FDL_DECARBONIZATION_TARGETS_STRATEGY: 304,
  UAE_FDL_VERIFICATION_COMPLIANCE: 305,
  UAE_FDL_INSIGHTS: 306
};

export const ReportPageType = {
  TITLE: 0,
  CONTENTS: 1,
  METRIC_DATA: 2,
  OTHERS: 3,
  OVERVIEW: 4,
  ESG_HIGHLIGHTS: 5,
  ABOUT_REPORT: 6,
  ABOUT_COMPANY: 7,
  ENERGY: 8,
  CARBON_EMISSION: 9,
  WASTE: 10,
  WATER: 11,
  ENV_OVERVIEW: 12,
  CUSTOMERS: 13,
  COMMUNITY: 14,
  EMPLOYEES: 15,
  SUPPLIERS: 16,
  SOCIAL_OVERVIEW: 17,
  ESG_GOV: 18,
  BOARD_GOV: 19,
  HUMAN_RIGHTS: 20,
  ETHICS_COMP: 21,
  TAX_POLICY: 22,
  BC_DIS_RECOVERY: 23,
  GOV_OVERVIEW: 24,
  ESG_GOALS: 25,
  MSG_FROM_CSO: 26,
  CONTRIB_TO_UN_SDGS: 27,
  BIODIVERSITY: 28,
  EXT_ASSURANCE: 29,
  E1: 30,
  E2: 31,
  E3: 32,
  E4: 33,
  E5: 34,
  S1: 35,
  S2: 36,
  S3: 37,
  G1: 38,
  S4: 39,
  SCORECARD: 40,
  TOPIC: 41,
  // TODO Use a common enum after migrating reports to reporting service,
  // the below 3 enums are itnentionally duplicated to avoid failure in cockpit enum match
  ENVIRONMENT: 30,
  SOCIAL: 31,
  GOVERNANCE: 32,
  SUST_CONTENT_INDEX: 33,
  GENERAL_DISCLOSURE: 42,
  GENERAL_INFO_OVERVIEW: 45,
  B1: 46,
  B2: 47,
  B3: 48,
  B4: 49,
  B5: 50,
  B6: 51,
  B7: 52,
  B8: 53,
  B9: 54,
  B10: 55,
  B11: 56,
  C1: 57,
  C2: 58,
  C3: 59,
  C4: 60,
  C5: 61,
  C6: 62,
  C7: 63,
  C8: 64,
  C9: 65,
  OVERVIEW_HIGHLIGHTS: 100,
  REPORT_BASIS_SCOPE: 101,
  ORGANISATIONAL_STRUCTURE_BOUNDARIES: 102,
  REPORTING_BASE_YEAR_APPROACH: 103,
  EMISSIONS_ACCOUNTING: 104,
  ENERGY_MIX_EMISSION_SOURCES: 105,
  GHG_MANAGEMENT_PERFORMANCE: 106,
  VERIFICATION_INVENTORY_QUALITY: 107,
  REFERENCES_SUPPORTING_MATERIALS: 108,
  INSIGHTS: 109,
  SECTION: 200,
  PRINCIPLE: 201,
  // UAE Federal Decree-Law report pages (300+)
  UAE_FDL_ABOUT_THE_ORGANIZATION: 300,
  UAE_FDL_OBJECTIVES_OF_DECREE_LAW: 301,
  UAE_FDL_GHG_EMISSIONS_INVENTORY: 302,
  UAE_FDL_INFORMATION_ABOUT_EMISSIONS: 303,
  UAE_FDL_DECARBONIZATION_TARGETS_STRATEGY: 304,
  UAE_FDL_VERIFICATION_COMPLIANCE: 305,
  UAE_FDL_INSIGHTS: 306
};

export const OfficePageType = {
  TERMS_OF_USE: 0,
  PRIVACY_NOTICE: 1,
  GDPR_STATEMENT: 2
};

// Local storage keys
export const LS_TERMS_AGREED_KEY = 'termsAgreed';
export const METRIC_CODE = 'MetricCode';
export const STANDARD_SELECTED = 'stdName';
export const LS_AUTHORITY_KEY = 'authority';
export const LS_CATEGORY_NAME_KEY = 'categoryName';
export const LS_REGULATION_SELECTED_KEY = 'regulationSelected';
export const LS_ACTIVE_ASSESSMENT_LIST_KEY = 'activeAssessmentList';
export const LS_ACCESS_TOKEN_KEY = 'accessToken';
export const LS_DV_FILTER_KEY = 'dvFilter';
export const LS_COMPANY_INFO_KEY = 'companyInfo';
export const LS_AI_CONFIG_KEY = 'aiConfig';
export const LS_USER_ONBOARD_KEY = 'userOnboardData';
export const LS_UI_ELEMENTS_CONFIG_KEY = 'uiElementsConfig';
export const CWD_ID = 'cwd_id';
export const LS_COMP_FILTER_KEY = 'compFilter';
export const LS_SELECTED_MAT_ISSUE_YEAR = 'MatIssueSelYear';
export const LS_GHG_DV_FILTER_KEY = 'ghgdvFilter';
export const LS_CONTENT_BLOCKS_FILTER_KEY = 'contentBlocksFilter';
export const LS_ESG_FILTER_KEY = 'esgFilter';
export const LS_DCE_FILTER_KEY = 'dceFilter';
export const LS_DCE_SUBMISSION_FILTER_KEY = 'dceSubmissionFilter';
export const LS_HOME_PAGE_YEAR_KEY = 'homePageSelectedYear';
export const LS_HOME_PAGE_YEAR_USER_SELECTED_KEY = 'homePageYearUserSelected';

export const TASK_STATUS = [
  { value: 'NEW', label: 'New' },
  { value: 'IN_PROGRESS', label: 'Inprogress' },
  { value: 'CLOSED', label: 'Closed' }
];

export const TASK_PRIORITY = [
  { value: '0', label: 'Low' },
  { value: '1', label: 'Medium' },
  { value: '2', label: 'High' },
  { value: '3', label: 'Critical' }
];

export const BusinessUnitTypes = [
  { id: 1, name: 'Branch' },
  { id: 2, name: 'Department' },
  { id: 3, name: 'Asset' },
  { id: 4, name: 'Site' },
  { id: 5, name: 'Location' },
  { id: 6, name: 'Subsidiary' },
  { id: 7, name: 'Joint Venture' },
];

export const DataViewCategoryType = {
  ENVIRONMENTAL: 0,
  SOCIAL: 1,
  GOVERNANCE: 2
};

export const CompareCategoryType = {
  0: 'ENVIRONMENTAL',
  1: 'SOCIAL',
  2: 'GOVERNANCE'
};

export const BACKSPACE_EVT_KEY = 'Backspace';
export const DELETE_EVT_KEY = 'Delete';

export function GDQuestionCategory({ t }) {
  const options = [
    { value: "GRI_1", label: "GRI 1: Foundation" },
    { value: "GRI_2", label: "GRI 2: General Disclosures" },
    { value: "GRI_3", label: "GRI 3: Material Topics" },
    { value: "BRSR", label: "BRSR" },
  ];
  return options;
} withTranslation()(GDQuestionCategory);

export const CategoryType = {
  SOCIAL: 'SOCIAL',
  ENVIRONMENTAL: 'ENVIRONMENTAL',
  GOVERNANCE: 'GOVERNANCE',
  GRI_1: 'GRI_1',
  GRI_2: 'GRI_2',
  GRI_3: 'GRI_3',
};

export const CompanyDashboardGraphType = {
  AVG_EENRGY_INT_BY_ORE_MILLED: 1,
  ENERGY_INT_BY_METAL_PROD: 2,
  SCOPE_123_EMISSION: 3,
  SOCIAL_EMPLOYMENT: 4,
  ECONO_VALUE_DISTRIBUTED: 5,
  ECONO_VALUE_GENERATED: 6,
  WASTE_DISPOSAL: 7,
  ENERGY_PRODUCED: 8,
  SUSTAINABLE_FINANCE: 9,
  ENERGY_CONS_OUTSIDE_ORG: 11,
  WASTE_GEN_IN_ORG: 12,
  SCOPE_123_EMISSION_ACROSS_SITE: 13,
  TOTAL_WATER_CONS_IN_ORG: 14,
  ENERGY_CONS_WITHIN_ORG: 15
};

export const AnalyticsReportType = {
  ENERGY_PRODUCED: { id: 1, code: 'ENERGY_PRODUCED' },
  ENERGY_CONSUMPTION_WITHIN_THE_ORGANIZATION: { id: 2, code: 'ENERGY_CONSUMPTION_WITHIN_THE_ORGANIZATION' },
  ENERGY_CONSUMPTION_OUTSIDE_THE_ORGANIZATION: { id: 3, code: 'ENERGY_CONSUMPTION_OUTSIDE_THE_ORGANIZATION' },
  ENERGY_CONSUMPTION_WITHIN_THE_ORGANIZATION_V2: { id: 4, code: 'ENERGY_CONSUMPTION_WITHIN_THE_ORGANIZATION_V2' },
  TOTAL_WATER_CONSUMPTION_IN_THE_ORGANIZATION: { id: 5, code: 'TOTAL_WATER_CONSUMPTION_IN_THE_ORGANIZATION' },
  SUSTAINABLE_FINANCE: { id: 6, code: 'SUSTAINABLE_FINANCE' },
  SCOPE_1_2_3_EMISSION: { id: 7, code: 'SCOPE_1_2_3_EMISSION' },
  SCOPE_1_2_3_EMISSION_ACROSS_SITE: { id: 8, code: 'SCOPE_1_2_3_EMISSION_ACROSS_SITE' },
  WASTE_GENERATED_IN_ORG: { id: 9, code: 'WASTE_GENERATED_IN_ORG' },
  WASTE_DISPOSAL_IN_ORG: { id: 10, code: 'WASTE_DISPOSAL_IN_ORG' }
};

export const ANOMALY_DETECT_POLLING_INTERVAL = 3000;
export const ANOMALY_DETECT_MAX_POLL_RETRIES = 3;
export const ANOMALY_DETECT_STORAGE_KEY = "anomaly_detect_job";
export const ANOMALY_LAST_DETECT_KEY = "anomaly_last_detect_run";

export const POLLING_INTERVAL = 30000; // 30 seconds
export const DATA_VIEW_IMPORT_POLLING_INTERVAL = 10000; // 10 seconds
export const FINALIZE_CONFIG_POLLING_INTERVAL = 10000; // 10 seconds
export const POLLING_SALT = [1000, 2000, 3000, 4000, 5000];
export const PollerAction = {
  IDLE: 0,
  START: 1,
  STOP: 2
};
export const PollerType = {
  NONE: 0,
  REPORT_BUILDER: 1
};
export const AIReportJobStatus = {
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  NOT_STARTED: 'not-started'
};

export const ReportGenerationJobStatus = {
  DRAFT: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 3
};

export function ReportGenerationStandard({ t }) {
  const options = [
    { value: "GRI", label: "GRI" },
    { value: "SASB", label: "SASB" },
    { value: "BRSR", label: "BRSR" },
    { value: "TCFD", label: "TCFD" },
  ];
  return options;
} withTranslation()(ReportGenerationStandard);

export function RefinedTextRating({ t }) {
  const options = [
    { value: 1, label: t("Poor.label") },
    { value: 2, label: t("Fair.label") },
    { value: 3, label: t("Good.label") },
  ];
  return options;
} withTranslation()(RefinedTextRating);

export const UI_MODULES = [
  { id: 'CARBON_EMISSION', text: 'Carbon Emisison' },
  { id: 'SETTINGS_COMP_DETAILS', text: 'Settings >> Company >> Company Details' },
  { id: 'SETTINGS_USERS', text: 'Settings >> Users' },
  { id: 'SUPPORT', text: 'Support' },
  { id: 'USER_PROFILE', text: 'User Profile' },
];

export const UI_ELEMENTS_TEXTUAL_KEYS = [
  { key: 'dashboard', text: 'Dashboard' },
  { key: 'footer', text: 'Footer' },
  { key: 'privacyPolicy', text: 'Privacy Policy' },
  { key: 'termsAndConditions', text: 'Terms & Conditions' },
  { key: 'esgAI', text: 'ESG AI' },
  { key: 'appTitle', text: 'Applcation Title' },
  { key: 'homePageURL', text: 'Home Page URL' },
  { key: 'partnerLogoURL', text: 'Partner Logo URL' },
  { key: 'copilotHelp', text: 'Copilot Help' },
];

export const ReportedFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  HALF_YEARLY: 'HALF_YEARLY',
  YEARLY: 'YEARLY'
};

export const ReportedFrequencyList = [
  { key: ReportedFrequency.MONTHLY, text: 'Monthly' },
  { key: ReportedFrequency.QUARTERLY, text: 'Quarterly' },
  { key: ReportedFrequency.HALF_YEARLY, text: 'Half Yearly' },
  { key: ReportedFrequency.YEARLY, text: 'Yearly' },
];

export const CapturedFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  HALF_YEARLY: 'HALF_YEARLY',
  YEARLY: 'YEARLY'
};

export const CapturedFrequencyList = [
  { key: ReportedFrequency.DAILY, text: 'Daily' },
  { key: ReportedFrequency.WEEKLY, text: 'Weekly' },
  { key: ReportedFrequency.MONTHLY, text: 'Monthly' },
  { key: ReportedFrequency.QUARTERLY, text: 'Quarterly' },
  { key: ReportedFrequency.HALF_YEARLY, text: 'Half Yearly' },
  { key: ReportedFrequency.YEARLY, text: 'Yearly' },
];

export const KPIStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const KPIStatusList = [
  { key: KPIStatus.NOT_STARTED, text: 'Not Started' },
  { key: KPIStatus.IN_PROGRESS, text: 'In Progress' },
  { key: KPIStatus.COMPLETED, text: 'Completed' },
];

export const EventType = {
  REFRESH_REPORT_LIST: 'Refresh Report List',
  REFRESH_COMPANY_GRAPHS: 'REFRESH_COMPANY_GRAPHS',
  DOUBLE_MAT_YEAR_CHANGED: 'DOUBLE_MAT_YEAR_CHANGED'
};

export const StandardCategory = {
  QUANTITATIVE: 0,
  QUALITATIVE: 1
};

export const DATA_COLLECTION_IMPORT_POLLING_INTERVAL = 10000; // 10 seconds
export const DC_ITEMS_PER_PAGE = 100;
export const ITEMS_COUNT_PAGINATION_OPTION_DC = [
  { value: 100, label: "100" },
  { value: 200, label: "200" },
  { value: 500, label: "500" },
];

export const FormFrequency = {
  MONTHLY: { text: 'MONTHLY', value: 'Monthly' },
  QUARTERLY: { text: 'QUARTERLY', value: 'Quarterly' },
  HALF_YEARLY: { text: 'HALF_YEARLY', value: 'Half Yearly' },
  ANNUALLY: { text: 'ANNUALLY', value: 'Annually' }
};

export const CalendarEventType = {
  DCE_CREATION: 'DCE_CREATION'
};

export const AICopilotStyleType = {
  STYLE1: 0,
  STYLE2: 1,
  STYLE4: 2,
  STYLE7: 3
};

export const AICopilotToneType = {
  TONE1: 0,
  TONE2: 1,
  TONE3: 2,
  TONE7: 3
};

export const AICopilotReportSectionType = {
  ESGGOALS: 0,
  ENVIRONMENTOVERVIEW: 1,
  ENVIRONMENTENERGY: 2,
  ENVIRONMENTCARBONEMISSIONS: 3,
  ENVIRONMENTWASTE: 4,
  ENVIRONMENTWATERCONSUMPTION: 5,
  SOCIALOVERVIEW: 6,
  SOCIALCUSTOMERS: 7,
  SOCIALCOMMUNITY: 8,
  SOCIALEMPLOYEES: 9,
  SOCIALSUPPLIERS: 10,
  GOVERNANCEOVERVIEW: 11,
  GOVERNANCEESGGOVERNANCE: 12,
  GOVERNANCEBOARDGOVERNANCE: 13,
  GOVERNANCEHUMANRIGHTS: 14,
  GOVERNANCEETHICSCOMPLIANCE: 15,
  GOVERNANCETAXPOLICY: 16,
  ABOUTTHECOMPANY: 17,
  ABOUTTHEREPORT: 18,
  DYNAMICSECTION: 19
};

export const AICopilotWordCount = {
  SHORT: 0, MEDIUM: 1, LONG: 2, AUTO: 3
};

export const FormType = {
  GENERAL: 'GENERAL',
  FEEDBACK: 'FEEDBACK',
  ASSESSMENT: 'ASSESSMENT',
  SURVEY: 'SURVEY'
};

export const QuestionType = [
  { key: 'PAGE', text: 'Page' },
  { key: 'SECTION', text: 'Section' },
  { key: 'SUB_SECTION', text: 'Sub Section' },
  { key: 'SINGLE_VALUE', text: 'Single Value' },
  { key: 'TYPE_1_TABLE', text: 'Table Normal' },
  { key: 'TYPE_2_TABLE', text: 'Table with static cell config' },
  { key: 'TYPE_3_TABLE', text: 'Table with dynamic cell config' },
  { key: 'TYPE_6_TABLE', text: 'Table data with base year to current year' },
  { key: 'TYPE_5_TABLE', text: 'Table with entity wise data (Quantitative)' },
  { key: 'TYPE_7_TABLE', text: 'Table with entity wise data (Qualitative)' }
  
];

export const QuestionTypeLabel = {
  PAGE: 'Page',
  SECTION: 'Section',
  SUB_SECTION: 'Sub Section',
  SINGLE_VALUE: 'Single Value',
  TYPE_1_TABLE: 'Table Normal',
  TYPE_2_TABLE: 'Table with static cell',
  TYPE_3_TABLE: 'Table with dynamic cell',
  TYPE_5_TABLE: 'Table with entity wise data (Quantitative)',
  TYPE_6_TABLE: 'Table data with base year to current year',
  TYPE_7_TABLE: 'Table with entity wise data (Qualitative)',
};

export const DataPeriod = {
  NONE: 'NONE',
  BASE_YEAR: 'BASE_YEAR'
};

export const Pages = [
  { key: '1', text: 'Page 1' },
  { key: '2', text: 'Page 2' },
  { key: '3', text: 'Page 3' },
  { key: '4', text: 'Page 4' },
  { key: '5', text: 'Page 5' },
  { key: '6', text: 'Page 6' },
  { key: '7', text: 'Page 7' },
  { key: '8', text: 'Page 8' },
  { key: '9', text: 'Page 9' },
  { key: '10', text: 'Page 10' },
  { key: '11', text: 'Page 11' },
];

export const localeMap = {
  enUS: enUS,
  ar: ar,
  de: de
};

export const MaterialIssueVersionStatus = {
  DRAFT: 0,
  FINALIZED: 1,
  FAILED: 2
};

export const MaterialityImpactRange = {
  NO: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  VERY_HIGH: 4
};

export const languageOptions = [
  { code: 'en-uk', name: 'English - UK' },
  { code: 'en-us', name: 'English - US' },
  { code: 'de', name: 'Deutsch' }
];


export const VSME_PAGES = [
  { key: '1', text: 'B1' },
  { key: '2', text: 'B2' },
  { key: '3', text: 'B3' },
  { key: '4', text: 'B4' },
  { key: '5', text: 'B5' },
  { key: '6', text: 'B6' },
  { key: '7', text: 'B7' },
  { key: '8', text: 'B8' },
  { key: '9', text: 'B9' },
  { key: '10', text: 'B10' },
  { key: '11', text: 'B11' },
  { key: '12', text: 'C1' },
  { key: '13', text: 'C2' },
  { key: '14', text: 'C3' },
  { key: '15', text: 'C4' },
  { key: '16', text: 'C5' },
  { key: '17', text: 'C6' },
  { key: '18', text: 'C7' },
  { key: '19', text: 'C8' },
  { key: '20', text: 'C9' },
];

export const GraphLayoutType = {
  GENERIC: { name: 'GENERIC', value: 0, text: 'Generic' },
  SCOPE_1: { name: 'SCOPE_1', value: 1, text: 'Scope 1' },
  SCOPE_2: { name: 'SCOPE_2', value: 2, text: 'Scope 2' },
  SCOPE_3: { name: 'SCOPE_3', value: 3, text: 'Scope 3' },
  OVERVIEW: { name: 'OVERVIEW', value: 4, text: 'Overview' },
};

export const GHGPossibleUnits = ['kg CO2/mmBtu','gallon','MWh', 'scf', 'tco2/mwh', 'kg CO2e']


export const MaterialityImpactType = {
  FINANCIAL: 'FINANCIAL', 
  IMPACT: 'IMPACT', 
  IMPORTANCE: 'IMPORTANCE'
};


export const MaterialityType = {
  SINGLE: 'SINGLE', 
  DOUBLE: 'DOUBLE',
};


export const ReportSettingsFrequency = {
  CALENDAR_YEAR: 'CALENDAR_YEAR',
  FINANCIAL_YEAR: 'FINANCIAL_YEAR'
};

export const ReportBasis = {
  ORG: 'ORG',
  ENTITY: 'ENTITY'
};

export const QUESTION_STANDARDS = [
  { value: 'ESRS', label: 'ESRS' },
  { value: 'VSME', label: 'VSME' },
  { value: 'GHG', label: 'GHG' },
  { value: 'BRSR', label: 'BRSR' },  
  { value: 'UAE_FDL', label: 'UAE-FDL' }
];

export const GHG_PAGES = [
  { key: '1', text: 'Page 1' },
  { key: '2', text: 'Page 2' },
  { key: '3', text: 'Page 3' },
  { key: '4', text: 'Page 4' },
  { key: '5', text: 'Page 5' },
  { key: '6', text: 'Page 6' },
  { key: '7', text: 'Page 7' },
  { key: '8', text: 'Page 8' },
  { key: '9', text: 'Page 9' },
  { key: '10', text: 'Page 10' }
];

export const EquationBuilderFor = {
  GRAPH_CONFIG: 0,
  ESG_DATASET: 1,
  KPI: 2,
  ESG_ANALYTICS: 3
};

/** Decimal places for graph/chart value display (tooltips, axis labels, stacked totals) */
export const GRAPH_FRACTION_DIGITS = 4;

export const SANKEY_NODE_TYPE = {
  METRIC: 'METRIC',
  DP: 'DP'
};

export const UAE_FDL_PAGES = [
  { key: '1', text: 'Page 1' },
  { key: '2', text: 'Page 2' },
  { key: '3', text: 'Page 3' },
  { key: '4', text: 'Page 4' },
  { key: '5', text: 'Page 5' },
  { key: '6', text: 'Page 6' },
  { key: '7', text: 'Page 7' }
];

export const EQUATION_EXECUTION_POLLING_INTERVAL = 5000; // 5 seconds

export const FREQUENCY_OPTIONS = [
  { key: 'SUMMARY', labelKey: 'Summary.label' },
  { key: 'ANNUALLY', labelKey: 'ANNUALLY.label' },
  { key: 'HALF_YEARLY', labelKey: 'HALF_YEARLY.label' },
  { key: 'QUARTERLY', labelKey: 'Quarterly.label' },
  { key: 'MONTHLY', labelKey: 'Monthly.label' },
];

export const ALL_STATUSES = "COMPLETED,PENDING_APPROVAL,CORRECTION_PENDING,IN_PROGRESS,DRAFT";

export const STATUS_LABEL_KEYS = {
  COMPLETED: 'Completed.label',
  PENDING_APPROVAL: 'PendingApproval.label',
  CORRECTION_PENDING: 'CorrectionPending.label',
  IN_PROGRESS: 'InProgress.label',
  NOT_STARTED: 'Notstarted.label',
};